import React from 'react';
import { cls } from '../../packages/components';
import Asset from '../../requests/apa/Asset';
import EventTag from './EventTag';
import PersistentMiniEpgRecordIcon from './PersistentMiniEpgRecordIcon';

const PersistentMiniEpgEvent = ({ type = '', effectsEnabled}) => {
  const reminderAsset = Asset.get('modal_option_reminder_icon', '/images/ic_clock.png')
  return (
    <div
      className={cls(
        "mini-event-container",
        "mini-row",
        "focusable",{
          "focusEffect": effectsEnabled
        })}
      id={`mini-${type}-event`}
    >
      <div className="mini-event-container-float">
        <div
          className="mini-event-image-container mini-row"
          id={`mini-${type}-event-image-container`}
          style={{ display: 'none' }}
        >
          <img id={`mini-${type}-event-image`} alt="event" />
        </div>
        <div
          className="mini-event-info-container mini-row"
          id={`mini-${type}-event-info-container`}
        >
          <div className="mini-event-info-float">
            <div
              className="mini-event-record-container mini-column"
            >
              <span id={`mini-${type}-event-record-label`}></span>
              <PersistentMiniEpgRecordIcon type={type}/>
            </div>
            <div
              className="mini-event-title-container mini-column"
              id={`mini-${type}-event-title`}
            ></div>

            <div className="mini-event-schedule-tag-container mini-column">
              <div className="mini-event-schedule-container mini-row">
                <span id={`mini-${type}-event-schedule`}></span>
              </div>
              <EventTag
                wrapperId={`mini-${type}-event-tag-container`}
                spanId={`mini-${type}-event-tag`}
                style={{ display: 'none' }}
              />
              <img src={reminderAsset} id={`mini-${type}-event-reminder-icon`} className="mini-event-reminder-icon" alt="clock"/>
              {/* <i id={`mini-${type}-event-reminder-icon`} className="fa fa-clock-o mini-event-reminder-icon"/> */}
            </div>
            <div id={`mini-${type}-event-progress-container`} className="mini-event-progress-container">
              <div id={`mini-${type}-event-progress-line`} className="mini-event-progress-line" />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PersistentMiniEpgEvent;



// WEBPACK FOOTER //
// ./src/components/PersistentMiniEpg/PersistentMiniEpgEvent.jsx